export default __webpack_public_path__ + "static/media/yellow_squeeze_up.06e0c2bd.png";